export default (node) => {
  /**
   * Data + elements
   */
  let variants = node.dataset.variants;
  variants = JSON.parse(variants) || [];

  const colorVariants = node.querySelectorAll(
    '[data-product-variant-color-container]'
  );

  const currentColorName = node.querySelector('[data-product-current-color]');

  /**
   * Functions
   */
  const handleColorVariantClick = (e) => {
    const colorVariant = e.currentTarget;
    const colorName = colorVariant.dataset.productVariantColorName;
    currentColorName.textContent = colorName;
    colorVariants.forEach((colorVariant) => {
      colorVariant.classList.remove('image-selected');
      const colorVariantButton = colorVariant.querySelector(
        '[data-product-variant-button]'
      );
      colorVariantButton.dataset.productVariantButton = 'false';
    });
    colorVariant.classList.add('image-selected');
    const currentColorVariantButton = colorVariant.querySelector(
      '[data-product-variant-button]'
    );
    currentColorVariantButton.dataset.productVariantButton = 'true';
    presetImage();
  };

  const presetImage = () => {
    const imageSelected = document.querySelector(
      '[data-product-variant-color-container].image-selected'
    );
    if (imageSelected) {
      const mediaEl = imageSelected.querySelector('[data-media-id]');
      if (mediaEl) {
        const mediaId = mediaEl.dataset.mediaId;
        const mediaElements = document.querySelectorAll('[data-swiper-thumb]');
        mediaElements.forEach((mediaElement) => {
          if (mediaElement.dataset.mediaId === mediaId) {
            document.dispatchEvent(
              new CustomEvent('product-image:scroll-to-image', {
                detail: {
                  node: mediaElement,
                },
              })
            );
          }
        });
      }
    }
  };

  /**
   * Init
   */
  const init = () => {
    presetImage();
    colorVariants.forEach((colorVariant) => {
      colorVariant.addEventListener('click', handleColorVariantClick);
    });
  };

  init();
};
